import React from 'react'
import { DocumentDropzone } from 'src/services/documents/components/DocumentDropzone'
import { useToasts } from 'src/services/toasts'

interface IDropzoneWrapperProps {
  dropzoneInputRef: React.MutableRefObject<React.RefObject<HTMLInputElement> | null>
  uploadDocument: (file: File) => Promise<void>
  hasDocuments: boolean
  children: React.ReactNode
}

const DropzoneWrapper: React.FC<IDropzoneWrapperProps> = ({
  dropzoneInputRef,
  uploadDocument,
  hasDocuments,
  children,
}) => {
  const postToast = useToasts()

  return (
    <DocumentDropzone
      inputRef={dropzoneInputRef}
      onDropFileError={(errorMessage) => {
        postToast({
          content: errorMessage,
          type: 'alert',
        })
      }}
      onDropFilesSuccess={(files) => {
        files.forEach(uploadDocument)
      }}
      hasNoFiles={!hasDocuments}
    >
      {children}
    </DocumentDropzone>
  )
}

export { DropzoneWrapper }
